import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchLink } from 'redux/links/actions';

import { Checkbox } from 'semantic-ui-react';

import './CommonLinkTwitterOptions.css';

function CommonLinkTwitterOptions(props) {
  const{ linkItem, patchLink } = props;
  const linkData = linkItem.link_data;
  const { t } = useTranslation();

  const [optionsArray, setStateOptionsArray] = useState([
    {
      label: t("Link off to Twitter"),
      dataDisplay: "tweet_link",
      link_data: linkData.tweet_url,
      checked: true,
    },
    { 
      label: t("Display this Tweet on my HeyLink.me"),
      dataDisplay: "tweet_embed",
      link_data: linkData.tweet_embed,
      checked: false,
    },
    {
      label: t("Link off to this profile’s latest Tweet"),
      dataDisplay: "latest_tweet_link",
      link_data: linkData.latest_tweet_url,
      checked: false,
    },
    { 
      label: t("Display this profile’s latest Tweet on my HeyLink.me"),
      dataDisplay: "latest_tweet_embed",
      link_data: linkData.latest_tweet_embed,
      checked: false,
    },
  ]);

  useEffect(() =>{
    chooseTweetDisplay(linkItem.twitter_link_type, false);
  }, []);

  const chooseTweetDisplay = (id, sendRequest = true) => {
    const checkArr = optionsArray.map(item => {
      if (item.dataDisplay === id) {
        const newItem = {
          ...item,
          checked: true,
        };

        if (sendRequest) {
          const form = new FormData();
          form.append('twitter_link_type', item.dataDisplay);
          form.append('is_embed', ['tweet_embed', 'latest_tweet_embed'].includes(item.dataDisplay));
          patchLink(linkItem.id, form);
        }
        
        return newItem;
      }

      if (item.dataDisplay !== id && item.checked) {
        return {
          ...item,
          checked: false,
        };
      }
      return item;
    });
    setStateOptionsArray(checkArr);
  };

  return (
    <div className="common-link-twitter-options__component">
      <div className="title">{t("Choose to display this Tweet")}</div>
      <div className="list-options">
        {optionsArray.map((item) => (
          <div className="checkbox-wrapper" key={item.dataDisplay}>
            <Checkbox
              key={`twitter-option-checkbox-${item.dataDisplay}-${linkItem.id}`}
              id={`twitter-option-checkbox-id-${item.dataDisplay}-${linkItem.id}`}
              label={item.label}
              data-display={item.dataDisplay}
              checked={item.checked}
              onChange={() => chooseTweetDisplay(item.dataDisplay)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

CommonLinkTwitterOptions.propTypes = {
  patchLink: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    patchLink,
  }
) (CommonLinkTwitterOptions);
